import { useState } from "react";
import { Alert, Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Form } from "react-final-form";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { LabNoteForm } from "./LabNotesForm";
import { snakifyKeys } from "../../../util/helpers";

export const CreateLabNoteModal = ({ labId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    setError(null);
    try {
      values.lab_id = labId;
      const res = await api.post("/admin/lab_notes", { lab_note: snakifyKeys(values) });

      if (onCreate) {
        onCreate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Note...
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Create New Note</ModalHeader>

        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}

          <Form onSubmit={handleCreate}>{(props) => <LabNoteForm {...props} />}</Form>
        </ModalBody>
      </Modal>
    </>
  );
};
